import { render, staticRenderFns } from "./ProductSelectionProductsRouterView.vue?vue&type=template&id=0ac427d2&"
import script from "./ProductSelectionProductsRouterView.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionProductsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports